export const defaultConnectionColor = '#9088DF';
export const positiveConnectionColor = '#53D68F';
export const negativeConnectionColor = '#fc4a54';
